<template>
  <div class="tuk-app-share">
    <div class="modal tuk-app-share-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal"></button>

      <div class="modal-card">
        <section class="modal-card-body">
          <p class="header">
            <svgicon
              icon="tuk-word"
              width="60"
              height="60"
              color="navy"
              :fill="true"
              style="margin-top: -14px; margin-right: 6px"
            ></svgicon>
            <span>APP</span>
            <a class="button is-white is-pulled-right">
              <i
                class="fa fa-share-alt fa-lg has-text-dark"
                @click="shareTUKApp"
              />
            </a>
          </p>

          <div style="padding: 8px 0">
            <qr-canvas :options="options" id="qr-code"></qr-canvas>
          </div>
          <div @click="gotoInstall" style="margin-bottom: 12px">
            <a class="link title">tukapp.co/install</a>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
// import EventBus from "../eventBus.js";
import { QRCanvas } from "qrcanvas-vue";
// import { sounds } from "../functions.js";

export default {
  name: "TUKAppShareModal",
  components: {
    QrCanvas: QRCanvas,
  },
  data() {
    return {
      error: "",
      logo: "/img/icons/round-180x180.png",
      // QR code generator options
      options: {
        cellSize: 8,
        correctLevel: "H",
      },
    };
  },
  computed: {},
  created() {
    const image = new Image();
    image.src = this.logo;
    image.onload = () => {
      this.options = Object.assign({}, this.options, {
        logo: { image },
        data: "https://tukapp.co/install",
      });
    };
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    gotoInstall() {
      window.open("https://tukapp.co/install", "_target");
    },
  },
};
</script>

<style scoped lang=scss>
.header {
  text-align: left;
  font-size: 1.4em;
  /* margin: 10px; */
  margin-top: 6px;
  margin-left: 4px;
}
.header span {
  font-size: 22pt;
  font-weight: 550;
  color: #fac002;
  margin-top: 4px;
  margin-left: -2px;
  position: absolute;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* bring your own prefixes */
}
.modal-card-body {
  /* width: 95vw; */
  margin: 0 auto;
  padding: 10px;
}
</style>
